<template>
  <div>
    <p style="margin-bottom: 0; padding-bottom: 0">
      <span style="color: rgba(0, 0, 0, 0.54); font-size: 10px; display: block">
        {{ $t("fullname") }}
      </span>
      <span style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); display: block">
        {{ toLatin(name) }}<template v-if="lastname">, {{ toLatin(lastname) }}</template>
      </span>
    </p>
    <p style="margin-bottom: 0; padding-bottom: 0">
      <span style="color: rgba(0, 0, 0, 0.54); font-size: 10px; display: block">
        {{ $t("address") }}
      </span>
      <span style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); display: block">
        {{ toLatin(address) }}
      </span>
    </p>
    <p style="margin-bottom: 0; padding-bottom: 0">
      <span style="color: rgba(0, 0, 0, 0.54); font-size: 10px; display: block">
        {{ $t("zip_code") }}
      </span>
      <span style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); display: block">
        {{ zip }}<template v-if="city">, {{ toLatin(city) }}</template>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "AddressSection",
  props: {
    name: {
      type: String,
      required: true,
    },
    lastname: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      required: true,
    },
    zip: {
      type: [String, Number],
      required: true,
    },
    city: {
      type: String,
      required: true,
    },
  },
};
</script>
